import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppTilesModule } from '../app-tiles/app-tiles.module';
import { DocumentsModule } from '../documents/documents.module';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { PwaComponent } from './pwa.component';

@NgModule({
    imports: [
        AppTilesModule,
        CommonModule,
        DocumentsModule,
        InstrumentationModule,
        LazyViewModule
    ],
    declarations: [
        PwaComponent
    ]
})
export class PwaModule {
}
